export default __webpack_public_path__ + "static/media/Australia_03.a0dca06e.png";